import { render, staticRenderFns } from "./list2.vue?vue&type=template&id=2bb75292&scoped=true"
import script from "./list2.vue?vue&type=script&lang=js"
export * from "./list2.vue?vue&type=script&lang=js"
import style0 from "./list2.vue?vue&type=style&index=0&id=2bb75292&prod&lang=scss&scoped=true"
import style1 from "./list2.vue?vue&type=style&index=1&id=2bb75292&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb75292",
  null
  
)

export default component.exports